/**
 * @module cercaliagl/view/BaseView
 */
import EventEmitter from 'eventemitter3';
import $ from 'jquery';
import { getDOMRelativePosition } from './VUtils';
/**
 * @enum {string}
 */
export var EventType = {
    ATTACHED: 'attached',
};
/**
 * @class BaseView
 */
var BaseView = /** @class */ (function () {
    /**
     * @constructor
     * @param {JQuery} jqElement jQuery Element
     */
    function BaseView(jqElement) {
        /**
         * @protected
         * @type {JQuery}
         */
        this.jqElement_ = jqElement;
        /**
         * @private
         * @type {EventEmitter}
         */
        this.eventEmitter_ = new EventEmitter();
    }
    /**
     * @return {Element} HTMLElement
     */
    BaseView.prototype.getElement = function () {
        return this.jqElement_.get(0);
    };
    /**
     * @return {JQuery} jQuery Element
     */
    BaseView.prototype.getJqElement = function () {
        return this.jqElement_;
    };
    /**
     * Adds the @listener function to the end of the listeners array
     * for the event named @eventName
     * Will ensure that only one time the listener added for the event
     *
     * @param {string} eventName Event name
     * @param {function} listener Listener
     */
    BaseView.prototype.on = function (eventName, listener) {
        this.eventEmitter_.on(eventName, listener);
    };
    /**
     * Will temove the specified @listener from @eventname list
     *
     * @param {string} eventName Event name
     * @param {function} listener Listener
     */
    BaseView.prototype.removeEventListener = function (eventName, listener) {
        this.eventEmitter_.removeListener(eventName, listener);
    };
    /**
     * Will emit the event on the evetn name with the @payload
     * and if its an error set the @error value
     *
     * @param {string} event Event
     * @param {object} [payload] Payload
     * @param {boolean} [error] Error
     */
    BaseView.prototype.emit = function (event, payload, error) {
        if (error === void 0) { error = false; }
        this.eventEmitter_.emit(event, payload, error);
    };
    /**
     * Returns the event emitter
     * Used for testing purpose and avoid using this during development
     * @return {EventEmitter} Event emitter
     */
    BaseView.prototype.getEventEmitter = function () {
        return this.eventEmitter_;
    };
    /**
     * @param {Element|HTMLElement} parent Parent node
     */
    BaseView.prototype.appendTo = function (parent) {
        $(this.jqElement_).appendTo($(parent));
        this.emit(EventType.ATTACHED, parent);
    };
    /**
     * @return {boolean} Open or not.
     */
    BaseView.prototype.isVisible = function () {
        return $(this.jqElement_).is(':visible');
    };
    /**
     * @param {boolean=} opt_animation Animation
     */
    BaseView.prototype.show = function (animation) {
        if (animation === void 0) { animation = true; }
        if (animation !== true) {
            this.jqElement_.show();
        }
        else {
            this.jqElement_.fadeIn();
        }
    };
    /**
     * @param {boolean=} opt_animation Animation
     */
    BaseView.prototype.hide = function (animation) {
        if (animation === void 0) { animation = true; }
        if (animation !== true) {
            this.jqElement_.hide();
        }
        else {
            this.jqElement_.fadeOut();
        }
    };
    /**
     * @return {HTMLElement}
     */
    BaseView.prototype.getMapViewport = function () {
        return this.jqElement_.closest('.mapboxgl-map ').get(0);
    };
    /**
     * @return {Object.<string, number>}
     */
    BaseView.prototype.getMapRelativePosition = function () {
        var element = this.jqElement_.get(0);
        return getDOMRelativePosition(element, this.getMapViewport());
    };
    return BaseView;
}());
export default BaseView;
//# sourceMappingURL=BaseView.js.map